import React from 'react';
import StackBar from './StackBar';
import { get } from 'lodash';
import moment from 'moment';

const ExperienceSidebar = ({ profile, statistics, at }) => {
  const { firstYearCertified, isCurrentStudent, graduationYear } = profile?.educationExperience || {};
  const totalShifts = statistics.jobCount || 0;
  const sports = get(statistics, 'experience.sports', []);
  const settings = get(statistics, 'experience.settings', []);

  return (
    <div className="experience-sidebar">
      <div className="at-card__header at-card__header--gray">EXPERIENCE</div>
      <div className="experience-sidebar__body">
        <div className="experience-sidebar__section">
          <div className="experience-sidebar__section-header">
            <span className="experience-sidebar__section-title">Sports worked</span>
            <span className="experience-sidebar__section-count">{totalShifts} SHIFTS</span>
          </div>
          <div className="experience-sidebar__bar-wrap">
            <StackBar tooltipTitle="Sports worked" segments={sports} height={10} showLegend={true} />
          </div>
        </div>

        <div className="experience-sidebar__section experience-sidebar__section--bordered">
          <div className="experience-sidebar__section-header">
            <span className="experience-sidebar__section-title">Settings</span>
            <span className="experience-sidebar__section-count">{totalShifts} SHIFTS</span>
          </div>
          <div className="experience-sidebar__bar-wrap">
            <StackBar tooltipTitle="Settings worked" segments={settings} height={10} showLegend={true} />
          </div>
        </div>

        <div className="experience-sidebar__meta">
          <span>{isCurrentStudent ? 'Graduation year' : '1st year certified'}</span>
          <span className="experience-sidebar__meta-value">
            {isCurrentStudent ? graduationYear : firstYearCertified || '2011'}
          </span>
          <span>On Go4 since</span>
          <span className="experience-sidebar__meta-value">{moment(at.createdAt).format('MMM YY')}</span>
          <span>Go4 organizations worked with</span>
          <span className="experience-sidebar__meta-value">{statistics.organizationsWorkedWith}</span>
        </div>
      </div>
    </div>
  );
};

export default ExperienceSidebar;
